import { apiClient } from './client';

export const adminApi = {
  login: (email: string, password: string) =>
    apiClient.post('/admin/login', { email, password }).then((r) => r.data),

  getDashboard: () =>
    apiClient.get('/admin/dashboard').then((r) => r.data),

  getUsers: (page: number, limit: number, search?: string, status?: string) =>
    apiClient.get('/admin/users', { params: { page, limit, search, status } }).then((r) => r.data),

  getUserDetail: (id: string) =>
    apiClient.get(`/admin/users/${id}`).then((r) => r.data),

  getPicks: (page: number, limit: number, status?: string) =>
    apiClient.get('/admin/picks', { params: { page, limit, status } }).then((r) => r.data),

  getPickDetail: (id: string) =>
    apiClient.get(`/admin/picks/${id}`).then((r) => r.data),

  forcePickStatus: (id: string, status: string) =>
    apiClient.patch(`/admin/picks/${id}/status`, { status }).then((r) => r.data),

  forcePickPhase: (id: string, phase: string) =>
    apiClient.patch(`/admin/picks/${id}/phase`, { phase }).then((r) => r.data),

  forcePickDates: (id: string, dates: Record<string, string>) =>
    apiClient.patch(`/admin/picks/${id}/dates`, dates).then((r) => r.data),

  simulateProgress: (id: string, target: string) =>
    apiClient.post(`/admin/picks/${id}/simulate`, { target }).then((r) => r.data),

  getChains: (page: number, limit: number) =>
    apiClient.get('/admin/chains', { params: { page, limit } }).then((r) => r.data),

  getChainDetail: (id: string) =>
    apiClient.get(`/admin/chains/${id}`).then((r) => r.data),

  getStats: () =>
    apiClient.get('/admin/stats').then((r) => r.data),
};
